import styled from 'styled-components'
import { desktopBreakpoint } from 'react-components'

export const NonCarouselContainer = styled.div`
    display: ${props => props.theme.style.display.flex};
    justify-content: ${props => props.theme.style.justifyContent.center};
    margin: 3.125rem 3.125rem 0;
    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        margin: 2.8125rem 0 2.5rem;
    }
`
